import { END_POINTS_URL } from '@shopiroller/data';
import { HttpClient } from '@angular/common/http';
import { IReminderInformation } from '../../data';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';

@Injectable({
  providedIn: 'root',
})
export class ReminderService {
  constructor(private _http: HttpClient) {}

  public getInformation(appId: string): Observable<any> {
    const URL = `${END_POINTS_URL.V2.APPS_URL}/${appId}/reminder`;
    return this._http.get(URL);
  }

  public setInformation(
    appId: string,
    payload: IReminderInformation
  ): Observable<any> {
    const URL = `${END_POINTS_URL.V2.APPS_URL}/${appId}/reminder`;
    return this._http.post(URL, payload);
  }
}
